import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { projectsData } from "../data/ProjectsData";
import Field from "./Field";
import LargeModal from "./LargeModal";

const Project = () => {
  const [search, setSearch] = useState("");
  const [show, setShow] = useState(false);
  const [projectData, setProjectData] = useState([]);

  const handleClose = () => setShow(false);
  const handleShow = (data) => {
    setProjectData(data);
    setShow(true);
  };
  const filteredArticles = projectsData.filter((project) => {
    const content = project.projectName + project.projectDesc + project.tags;
    return content.toLowerCase().includes(search.toLowerCase());
  });
  return (
    <div className='project_section'>
      <Container>
        <h1>My Projects</h1>
        <Field
          type='search'
          placeholder='Search projects'
          className='search-box'
          onChange={(e) => setSearch(e.target.value)}
        />
        <Row>
          {filteredArticles.length > 0 ? (
            filteredArticles.map((data, i) => {
              return (
                <Col lg={4}>
                  <div
                    className='project_card'
                    onClick={() => handleShow(data)}>
                    <h3>{data.projectName}</h3>
                    <p>{data.projectDesc}</p>
                    {data?.flag && <span>{data?.flag}</span>}
                  </div>
                </Col>
              );
            })
          ) : (
            <div className='norecords'>
              <h3>No Projects Found</h3>
            </div>
          )}
        </Row>
        <div></div>
      </Container>
      <LargeModal
        Title={projectData.projectName}
        message={projectData.projectDesc}
        show={show}
        handleClose={handleClose}
        projectData={projectData}
      />
    </div>
  );
};

export default Project;
